export enum RouteName {
  App = 'app',

  // Auth
  Login = 'login',
  Signup = 'signup',
  ForgotPassword = 'forgot-password',
  Onboarding = 'onboarding',
  Questionnaire = 'questionnaire',
  Questionnaire2 = 'questionnaire-2',
  CompleteRegistration = 'complete-registration',
  AgeRestricted = 'age-restricted',

  // Feed
  Feed = 'feed',
  Post = 'post',
  Story = 'story',
  Notifications = 'notifications',
  Chat = 'chat',
  Search = 'search',
  Recommendations = 'recommendations',
  Leaderboard = 'leaderboard',

  // Explore
  Plan = 'plan',
  Explore = 'explore',
  PlanDetails = 'plan-details',
  WorkoutPlayer = 'player',

  // Profile
  UserProfile = 'profile',
  PrivacyPolicy = 'privacy',
  TermsOfUse = 'terms',
  EditProfile = 'edit',
  ActivityLog = 'activity-log',
  Followers = 'followers',
  LikeExercises = 'liked-exercises',
  HiddenExercises = 'hidden-exercises',
  ChatDetails = 'chat-details',
  ChangePassword = 'change-password',
  WorkoutHistory = 'workout-history',
  PostHistory = 'post-history',
  Settings = 'settings',
  MutedUsers = 'muted-users',
  FitnessProfile = 'fitness-profile',
  PostView = 'post-view',
  SavedPosts = 'saved-posts',

  // Group
  Group = 'group',
  GroupHistory = 'history',
  CreateGroup = 'create',
  InviteToGroup = 'invite',
  InvitedToGroup = 'invited',

  // Routine
  Routine = 'routine',
  CustomizePlan = 'customize-plan',
  FilteredPlans = 'filtered-plans',
}
